import Element from 'ui/Element';

class MenuContainer extends Element {

}

export default MenuContainer;


// WEBPACK FOOTER //
// ./js/modules/ui/MenuContainer.es6